import {PaymentElement, useElements, useStripe} from "@stripe/react-stripe-js";
import {useState} from "react";
import MDButton from "../../../components/MDButton";
import Grid from "@mui/material/Grid";
import MDBox from "../../../components/MDBox";
import {useDispatch} from "react-redux";
import {attached_default_card, Logout, onErrorAlert} from "../../../actions";
import {Attached_Default_Card} from "../../../config";
import LocalStorage from "../../../utils/LocalStorage";
import {noop} from "lodash";
import {useNavigate} from "react-router-dom";
import {checkPermission, PERMISSION_DICT} from "../../../utils/Users_Roles_Permission";
import {useTranslation} from "react-i18next";

const CheckoutForm = ({customerId,defaultBtnAdded,setDefaultBtnAdded}) => {
    const stripe = useStripe();
    const elements = useElements();
    const dispatch = useDispatch()
    const nav = useNavigate()
    const {t} = useTranslation();

    const onError = (msg, code) => {
        setDefaultBtnAdded(false)
        dispatch(onErrorAlert(msg))
        if (code === 401) {
            dispatch(Logout(noop))
            nav('/')
        }
    }

    const saveFormData = () => {
        let formData = {}
        formData.ownerId = LocalStorage.getItem('ownerId')
        formData.username = LocalStorage.getItem('username')

        return formData
    }

    const onAttachedSuccess = () => {
        //dispatch(onSuccessAlert('Attached default card successfully'))
        nav(0)
        // let formData = {}
        // if (saveFormData()) {
        //     formData = saveFormData()
        // } else {
        //     return nav('/')
        // }
        // const axiosGet = async () => {
        //
        //     await dispatch(check_default_card(formData,noop,onError))
        //     //await dispatch(fetch_card_list(formData,noop,onError))
        // }
        //
        // axiosGet().then()
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!stripe || !elements) {
            return;
        }

        const { error, setupIntent } = await stripe.confirmSetup({
            elements,
            confirmParams: {},
            redirect: 'if_required',  // Ensure no redirection happens
        });

        if (error) {
            dispatch(onErrorAlert(error?.message))
        } else {
            const paymentMethodID = setupIntent.payment_method;
            let formData = {}
            formData.ownerId = LocalStorage.getItem('ownerId')
            formData.username = LocalStorage.getItem('username')
            formData.paymentMethodId = setupIntent.payment_method
            formData.customerId = customerId


            await dispatch(attached_default_card(formData,onAttachedSuccess,onError))
        }



    }


    return (
        <form onSubmit={handleSubmit}>
            <MDBox>
                <PaymentElement />
            </MDBox>
            <MDBox mt={2} sx={{display:'flex',justifyContent:'center'}}>
                <MDButton type="submit" variant={'gradient'} color={'warning'} disabled={!stripe || !checkPermission(PERMISSION_DICT.AccountPaymentId)}>
                    {t('AccountPage.Save Payment Method')}
                </MDButton>
            </MDBox>

        </form>
    )
};

export default CheckoutForm;